import { NuxtApp } from '#app'

export default defineNuxtPlugin((nuxtApp: NuxtApp) => {
  const vuePdfEmbed = defineAsyncComponent(() => import('vue-pdf-embed'))
  nuxtApp.vueApp.component('VuePdfEmbed', vuePdfEmbed)
})
